import {
  AZURE_SOURCE_TYPE_KEY,
  CSV_SOURCE_TYPE_KEY,
  GOOGLE_SOURCE_TYPE_KEY,
  LDAP_SOURCE_TYPE_KEY,
} from 'pages/Directory/consts';

type SourceType = 'csv' | 'azure-active-directory' | 'ldap' | 'google-directory' | string;

const currentSources = {
  CSV: CSV_SOURCE_TYPE_KEY,
  AZURE: AZURE_SOURCE_TYPE_KEY,
  LDAP: LDAP_SOURCE_TYPE_KEY,
  GOOGLE: GOOGLE_SOURCE_TYPE_KEY,
};

export default {
  ...currentSources,
  isCSV: (sourceType: SourceType) => sourceType === currentSources.CSV,
  isAzure: (sourceType: SourceType) => sourceType === currentSources.AZURE,
  isLDAP: (sourceType: SourceType) => sourceType === currentSources.LDAP,
  isGoogle: (sourceType: SourceType) => sourceType === currentSources.GOOGLE,
  isOath: (sourceType: SourceType) =>
    sourceType === currentSources.GOOGLE || sourceType === currentSources.AZURE,
};
